import React from "react";
import { useSelector } from "react-redux";
import Input from "../../../../components/inputs/inputs";
import Warning from "../../../../assets/images/icons/warning.svg";
import PricePerMeterRangeModal from "../../../../components/modals/admin/shippers/pricePerMeterRangeModal";

export default function ShippersRate1({
  handleChange,
  data,
  setData,
  submitted,
}) {
  const {
    base_fee_per_meter,
    insurance_percentage,
    tax_percentage,
    base_fee,
    base_fees_per_meter_by_range,
  } = data;

  const { settings } = useSelector((state) => state.application);

  return (
    <div>
      <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8">
        <div className="border-b border-[#E4E4F3] py-4 flex justify-between items-center mb-6">
          <h3 className="text-lg font-medium">Shipper Rates</h3>
        </div>
        <form name="form" id="shippers-form-rate1-edit">
          <div>
            <div className="mb-5">
              <div className="border border-gray-300 py-2 px-2 mb-2">
                <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                  Charge per meter (1m) :
                </h3>
                <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                  This is the charge per every meter travelled for delivery.
                </p>
                {settings?.checkout_fee_per_meter_status === "unavailable" && (
                  <div className="flex gap-1 mt-2">
                    <img src={Warning} alt="warning" />
                    <p className="text-primary text-[12px] sm:text-[14px]">
                      Currently disabled by system administrator
                    </p>
                  </div>
                )}
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <Input.Label
                    title={"Charge"}
                    value={base_fee_per_meter}
                    htmlFor={"base_fee_per_meter"}
                    name={"base_fee_per_meter"}
                    placeholder={"NGN 500"}
                    onChange={handleChange}
                  />
                  {submitted && !base_fee_per_meter && (
                    <div className="text-primary text-xs">Charge is required</div>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#151515] dark:text-white mb-2">
                    Charge per range
                  </label>
                  <PricePerMeterRangeModal
                    ranges={base_fees_per_meter_by_range}
                    setRanges={(ranges) =>
                      setData({ ...data, base_fees_per_meter_by_range: ranges })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="mb-8">
              <div className="border border-gray-300 py-2 px-2 mb-2">
                <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                  Insurance Rate (%) :
                </h3>
                <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                  This is the percentage calculated per declared 
                  value of customer items for insurance.
                </p>
              </div>
              <Input.Label
                title={"Insurance Percentage"}
                htmlFor={"insurance_percentage"}
                name={"insurance_percentage"}
                value={insurance_percentage}
                placeholder={"Enter Insurance percentage"}
                onChange={handleChange}
              />
              {submitted && !insurance_percentage && (
                <div className="text-primary text-xs">
                  Insurance rate is required
                </div>
              )}
            </div>
            <div className="mb-8">
              <div className="border border-gray-300 py-2 px-2 mb-2">
                <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                  Base Charge (NGN) :
                </h3>
                <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                  This is a company's profit margin.
                </p>
              </div>
              <Input.Label
                title={"Base Charge"}
                htmlFor={"base_fee"}
                value={base_fee}
                name={"base_fee"}
                placeholder={"Enter base Fee"}
                onChange={handleChange}
              />
              {submitted && !base_fee && (
                <div className="text-primary text-xs">
                  Base charge is required
                </div>
              )}
            </div>
            <div className="mb-8">
              <div className="border border-gray-300 py-2 px-2 mb-2">
                <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                  Tax Percentage (%) :
                </h3>
                <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                  This is a company's tax margin.
                </p>
              </div>
              <Input.Label
                title={"Tax Percentage"}
                htmlFor={"tax_percentage"}
                name={"tax_percentage"}
                value={tax_percentage}
                placeholder={"Enter tax Percentage"}
                onChange={handleChange}
              />
              {submitted && !tax_percentage && (
                <div className="text-primary text-xs">
                  Tax Percentage is required
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
